<template>
  <div>
    <v-simple-table v-if="invoice">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" v-for="(header, i) in headers" :key="i">
              {{ header[lang] }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in services" :key="service.name">
            <td>{{ service.title[lang] || service.title.en }}</td>
            <td>{{ service.unit_value }}</td>
            <td>{{ service.quantity }}</td>
            <td>{{ Number(service.total).toFixed(2) }}</td>
          </tr>

          <tr>
            <td style="border-top: 1px solid black">
              {{ translations.total[lang] }} ({{ translations.beforeVat[lang] }})
            </td>
            <td style="border-top: 1px solid black"></td>
            <td style="border-top: 1px solid black"></td>
            <td style="border-top: 1px solid black">
              {{ Number(services.reduce((a, c) => a + c.total, 0)).toFixed(2) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-else class="d-flex justify-center">
      <span>{{ translations.noData[lang] }}</span>
    </div>
  </div>
</template>

<script>
import translations from '@/utils/translations/general/settings/billingDashboard';
import upperFirst from 'lodash/upperFirst';

export default {
  name: 'BillingTable',

  mixins: [translations],

  props: {
    invoice: {
      type: [Object, Array],
    },
  },

  data: () => ({
    timer: null,
  }),

  computed: {
    lang() {
      return this.$route.params.lang;
    },
    headers() {
      return [
        this.translations.headerService,
        this.translations.headerUnitValue,
        this.translations.headerQuantity,
        this.translations.headerTotal,
      ];
    },

    services() {
      let services = [];

      for (const [key, value] of Object.entries(this.invoice)) {
        value.name = upperFirst(key.replace('_', ' '));
        value.total =
          (Number(value.unit_value || 0) - Number(value.unit_discount || 0)) *
          Number(value.quantity || 0);
        services.push(value);
      }

      return services;
    },
  },
};
</script>
